import React from 'react';
import { BarChart3, DollarSign, TrendingUp, Star } from 'lucide-react';
import { StatCard } from './adminShared';

// Admin dashboard "revenue" tab (extracted from AdminPage).
export const AdminRevenueTab = () => (
  <div className="space-y-6">
    {/* Revenue Stats */}
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      <StatCard icon={DollarSign} label="Total Revenue" value="$0" color="green" />
      <StatCard icon={TrendingUp} label="This Month" value="$0" color="blue" />
      <StatCard icon={Star} label="Tips" value="$0" color="purple" />
    </div>

    {/* Revenue Chart Placeholder */}
    <div className="bg-zinc-900/50 rounded-xl border border-zinc-800 p-6">
      <h3 className="font-semibold mb-4">Revenue Overview</h3>
      <div className="h-64 flex items-center justify-center border border-dashed border-zinc-700 rounded-lg">
        <div className="text-center">
          <BarChart3 className="w-12 h-12 text-zinc-600 mx-auto mb-2" />
          <p className="text-zinc-500">Connect Stripe for detailed analytics</p>
        </div>
      </div>
    </div>

    {/* Recent Transactions */}
    <div className="bg-zinc-900/50 rounded-xl border border-zinc-800 overflow-hidden">
      <div className="px-5 py-4 border-b border-zinc-800">
        <h3 className="font-semibold">Recent Transactions</h3>
      </div>
      <div className="px-5 py-8 text-center">
        <DollarSign className="w-12 h-12 text-zinc-600 mx-auto mb-2" />
        <p className="text-zinc-500">No transactions yet</p>
      </div>
    </div>
  </div>
);
